import { Autocomplete, TextField, Paper, createFilterOptions, FilterOptionsState } from '@mui/material'
import { styled } from '@mui/material/styles'
import { normaliseForComparison as normalise } from '../../../utils/name-utils'

// Default filter: normalises both the typed input value and the option labels
// before matching, so names with Turkish/special characters are findable when
// typed with plain ASCII (e.g. "sari" matches "Sarıgül").
const defaultFilterOptions: any = (options: any[], state: FilterOptionsState<any>) =>
  createFilterOptions<any>({
    ignoreAccents: false,
    ignoreCase: false,
    stringify: option => normalise(state.getOptionLabel(option)),
  })(options, { ...state, inputValue: normalise(state.inputValue) })

type AutoCompleteListProps<T> = {
  label: string
  id: string
  data: T[]
  textField: string
  value?: any
  error?: boolean
  getOptionLabel?: any
  filterOptions?: any
  disabled?: boolean
  multiple?: boolean
  onChange: (e: any, newValue: any | null) => void
  helperText?: string
  limitTags?: number
  disableClearable?: boolean
  isOptionEqualToValue?: (
    option: T,
    value: T
  ) => boolean
  dataTestId?: string
}

const StyledPaper = styled(Paper)`
  font-size: 13px !important;
`

function AutocompleteList<T>({
  id,
  label,
  data,
  disabled,
  getOptionLabel,
  filterOptions,
  textField,
  value,
  error,
  multiple = false,
  onChange,
  helperText,
  limitTags = 99,
  disableClearable = false,
  isOptionEqualToValue,
  dataTestId,
}: AutoCompleteListProps<T>) {
  return (
    <Autocomplete
      data-testid={dataTestId}
      PaperComponent={StyledPaper}
      multiple={multiple}
      id={id}
      disabled={disabled}
      disableClearable={disableClearable}
      options={data}
      getOptionLabel={(option: any) => option[textField]}
      filterOptions={filterOptions ?? defaultFilterOptions}
      value={value}
      onChange={onChange}
      limitTags={limitTags}
      sx={{
        '& .MuiButtonBase-root': {
          margin: '0px',
        }
      }}
      renderInput={params => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          error={error}
          helperText={helperText}
        />
      )}
      isOptionEqualToValue={isOptionEqualToValue}
    />
  )
}

export default AutocompleteList
export { defaultFilterOptions }
